import React from 'react';
import './operation-complete.scss';
import SuccessIcon from 'assets/icons/success.svg';
import PageCard from 'containers/PageCard';

interface IOperationComplete {
  main: React.ReactNode;
  footer?: React.ReactNode;
  title: string;
  minHeight?: string;
  onClose?: () => void;
}

export default function OperationComplete({
  main,
  footer,
  title,
  minHeight,
  onClose,
}: IOperationComplete) {
  return (
    <PageCard
      title={title}
      onClose={onClose}
      minHeight={minHeight || 'calc(100vh - 100px)'}
      main={
        <div className="operation-complete">
          <img
            className="mb_32"
            src={SuccessIcon}
            alt="Операция выполнена успешно"
          />
          {main}
        </div>
      }
      footer={
        footer && <div className="operation-complete__footer">{footer}</div>
      }
    />
  );
}
